<template>
  <div id="cart-bar">
    <div class="row">
      <div class="col-auto">
        <div class="cart-bar__total">
          {{ t('message["Total"]', 'Total') }}: AED
          <span class="price" :class="{ 'bounce': showBounce }">{{ totalCartPrice }}</span>
        </div>
      </div>
      <div class="col-auto ml-auto">
        <a class="cart-bar__btn" @click="$emit('show-cart')">
          {{ t('message["View Cart"]', 'View Cart') }}
        </a>
      </div>
    </div>    
  </div>
</template>

<script>
  import language from '../mixins/translate'
  import {
    mapGetters
  } from 'vuex'
  export default {
    mixins: [language],
    data() {
      return {
        showPrice: true,
        showBounce: false
      }
    },
    computed: {
      ...mapGetters('cart', ['totalCartPrice']),
    },
    watch: {
      totalCartPrice() {
        this.showBounce = true;
        setTimeout(() => {
          this.showBounce = false;
        }, 200)
      }
    }
  }
</script>


<style>




  #cart_bar p {
    margin-left: 11px;
    margin-top: 11px;
  }

  #cart_bar a {
    letter-spacing: normal !important;
    text-transform: none !important;
    font-weight: normal !important;
    padding: .375rem .75rem !important;
    margin-right: 11px;
    margin-top: 6px;
    font-size: 13px
  }
  .bounce-enter-active {
  animation: bounce-in .5s;
}
.bounce-leave-active {
  animation: bounce-in .5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
</style>
